import React from 'react';
import { Chip } from '@metarouter-private/mr-mui';

const MARKER_TEXT = 'The specific record for this entry could not be determined.';

export default function UnattributedMarker() {
  return <Chip data-test-id="auditLogUnattributedMarker" size="small" color="warning" label={MARKER_TEXT} />;
}
